import React from 'react';

export const CheckIconSvg = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35 20.1167V21.6667C34.9958 29.0478 30.1371 35.547 23.0589 37.6398C15.9807 39.7326 8.36898 36.9205 4.35158 30.7284C0.334187 24.5364 0.868098 16.4394 5.66378 10.8285C10.4595 5.21751 18.3745 3.42921 25.1167 6.43333"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.6667 6.66667L18.3333 25L13.3333 20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
